<script lang="ts">
	interface Props {
		count: number;
		active: number;
		buttonTransform?: boolean;
		color?: 'stone-5' | 'brown-2';
		onchange: (index: number) => void;
	}

	let {
		count,
		active = $bindable(0),
		buttonTransform = true,
		color = 'stone-5',
		onchange
	}: Props = $props();

	let buttonWidth = $state(8);
	let indicators = $derived(Array.from({ length: count }).map((_, i) => i));

	function getIndicatorScale(distance: number): number {
		switch (distance) {
			case 0:
				return 1;
			case 1:
				return 0.75;
			case 2:
				return 0.5;
			case 3:
				return 0.25;
			case 4:
				return 0.125;
			default:
				return 0;
		}
	}

	function getDistanceToActive(active: number, index: number): number {
		return Math.abs(active - index);
	}
</script>

<div class="flex min-w-32 justify-center">
	<div
		class="flex items-center gap-x-2 transition-transform duration-300"
		style={buttonTransform
			? `transform: translateX(calc(50% - ${16 * active + 0.5 * buttonWidth}px))`
			: ''}
	>
		{#each indicators as index}
			{@const current = index === active}
			{@const distanceToActive = getDistanceToActive(active, index)}
			<button
				bind:clientWidth={buttonWidth}
				type="button"
				aria-label={`Go to image ${index + 1}`}
				onclick={() => onchange(index)}
				class={[
					'h-2 w-2 rounded-full transition-all duration-300',
					`bg-${color}`,
					{
						'opacity-0': distanceToActive > 3,
						'opacity-50': !current && distanceToActive <= 3
					}
				]}
				style="transform: scale({getIndicatorScale(distanceToActive)});"
			></button>
		{/each}
	</div>
</div>
